import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function ToolCallCalculatorIcon(props: SimpleIconInterface): JSX.Element {
  const { stroke = IconColors.DarkGrey, ...rest } = props;

  return (
    <SimpleIcon {...rest} stroke={stroke} viewBoxDimensions="0 0 24 24">
      <path
        d="M18.75 0.75H5.25a1.5 1.5 0 0 0 -1.5 1.5v19.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5 -1.5V2.25a1.5 1.5 0 0 0 -1.5 -1.5Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="M16.5 3.75h-9a0.75 0.75 0 0 0 -0.75 0.75v3c0 0.414 0.336 0.75 0.75 0.75h9a0.75 0.75 0 0 0 0.75 -0.75v-3a0.75 0.75 0 0 0 -0.75 -0.75Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path d="M7.875 12.75a0.375 0.375 0 0 1 0 -0.75" stroke={stroke} strokeWidth={1.5} />
      <path d="M7.875 12.75a0.375 0.375 0 0 0 0 -0.75" stroke={stroke} strokeWidth={1.5} />
      <path d="M7.875 16.5a0.375 0.375 0 0 1 0 -0.75" stroke={stroke} strokeWidth={1.5} />
      <path d="M7.875 16.5a0.375 0.375 0 0 0 0 -0.75" stroke={stroke} strokeWidth={1.5} />
      <path d="M7.875 20.25a0.375 0.375 0 0 1 0 -0.75" stroke={stroke} strokeWidth={1.5} />
      <path d="M7.875 20.25a0.375 0.375 0 0 0 0 -0.75" stroke={stroke} strokeWidth={1.5} />
      <path d="M12.156 12.75a0.375 0.375 0 0 1 0 -0.75" stroke={stroke} strokeWidth={1.5} />
      <path d="M12.156 12.75a0.375 0.375 0 0 0 0 -0.75" stroke={stroke} strokeWidth={1.5} />
      <path d="M12.156 16.5a0.375 0.375 0 0 1 0 -0.75" stroke={stroke} strokeWidth={1.5} />
      <path d="M12.156 16.5a0.375 0.375 0 0 0 0 -0.75" stroke={stroke} strokeWidth={1.5} />
      <g>
        <path d="M12.156 20.25a0.375 0.375 0 0 1 0 -0.75" stroke={stroke} strokeWidth={1.5} />
        <path d="M12.156 20.25a0.375 0.375 0 0 0 0 -0.75" stroke={stroke} strokeWidth={1.5} />
      </g>
      <g>
        <path d="M16.125 12.75a0.375 0.375 0 0 1 0 -0.75" stroke={stroke} strokeWidth={1.5} />
        <path d="M16.125 12.75a0.375 0.375 0 0 0 0 -0.75" stroke={stroke} strokeWidth={1.5} />
      </g>
      <g>
        <path d="M16.125 16.5a0.375 0.375 0 0 1 0 -0.75" stroke={stroke} strokeWidth={1.5} />
        <path d="M16.125 16.5a0.375 0.375 0 0 0 0 -0.75" stroke={stroke} strokeWidth={1.5} />
      </g>
      <g>
        <path d="M16.125 20.25a0.375 0.375 0 0 1 0 -0.75" stroke={stroke} strokeWidth={1.5} />
        <path d="M16.125 20.25a0.375 0.375 0 0 0 0 -0.75" stroke={stroke} strokeWidth={1.5} />
      </g>
    </SimpleIcon>
  );
}
